{
  "home": {
    "title": "Bienvenida a",
    "subtitle": "Gestión inteligente de tus bodas y contratos.",
    "go": "Comenzar ahora",
    "next_wedding": "Próximo evento",
    "next_test": "Próximo ensayo",
    "no_wedding": "No hay eventos programados",
    "no_test": "Sin ensayos programados",
    "stats": {
      "weddings": "Eventos",
      "contracts": "Contratos"
    },
    "eyebrow": "Para maquilladoras y peluqueras de bodas",
    "hero_title_1": "El backstage perfecto",
    "hero_title_2": "de cada boda.",
    "hero_subtitle": "agenda orga-nized, equipo synchro-nized: gestiona clientes, contratos y citas sin perder tiempo.",
    "add": "Añadir",
    "features": {
      "contracts_title": "Contratos en un clic",
      "contracts_desc": "Genera contratos profesionales personalizados para cada cliente, listos para firmar.",
      "calendar_title": "Calendario siempre actualizado",
      "calendar_desc": "Bodas y pruebas en un solo calendario. Sin solapamientos, sin olvidos.",
      "clients_title": "Cada cliente, en su lugar",
      "clients_desc": "Fichas completas para cada novia: servicios, notas y documentos siempre a mano."
    },
    "create_event": "Crear evento",
    "dashboard": {
      "hello": "Hola",
      "overview": "Aquí tienes tu resumen",
      "upcoming": "Eventos próximos",
      "to_generate": "Contratos por generar",
      "open_balance": "Saldo pendiente",
      "to_collect": "por cobrar",
      "quick_actions": "Acciones rápidas",
      "new_event": "Nuevo evento",
      "open": "Abrir",
      "agenda": "Próximos eventos",
      "todo": "Tareas pendientes",
      "all_done": "Todo en orden",
      "to_sign": "Contratos por firmar",
      "deposits_to_collect": "Anticipos por cobrar",
      "next_trial": "Próxima prueba",
      "next_inspection": "Próxima visita",
      "no_trial": "Nada programado",
      "year_summary": "Resumen {{year}}",
      "events": "Eventos",
      "signed": "Contratos firmados",
      "signed_tooltip": "Eventos cuyo contrato ya tiene la firma registrada.",
      "expected": "Ingresos previstos",
      "expected_tooltip": "Valor total de todos los eventos del año, no solo lo que ya has cobrado: incluye también anticipos y saldos aún por recibir.",
      "collected": "Cobrado",
      "travel_title": "Desplazamientos",
      "km_year": "Km en {{year}}",
      "km_upcoming": "Km por recorrer",
      "travel_cost_year": "Total desplazamientos",
      "by_city": "Por ciudad",
      "other_cities": "+{{count}} ciudades más",
      "month_map": "Mapa del mes",
      "st_to_generate": "Por generar",
      "st_to_sign": "Por firmar",
      "st_deposit": "Anticipo",
      "st_ok": "Todo listo",
      "see_all": "Ver todos",
      "band_future": "Próximamente",
      "band_present": "En primer plano",
      "band_past": "Tu trayectoria",
      "quotes_sent": "Presupuestos enviados",
      "quote_expires": "Presupuesto, vence el {{date}}",
      "signature_expires": "Firma, vence el {{date}}",
      "events_done": "Eventos realizados",
      "collected_tooltip": "Anticipos y saldos que marcaste como pagados, sin desplazamientos.",
      "at_time": "a las {{time}}",
      "pro_teaser_title": "Estadísticas y mapas",
      "pro_teaser_text": "Los desplazamientos y el mapa de eventos están disponibles con el plan <strong>Pro</strong>.",
      "pro_teaser_cta": "Descubre Pro",
      "watch_title": "Para tener en cuenta",
      "watch_empty": "Todo tranquilo en los próximos {{days}} días",
      "countdown_today": "hoy",
      "countdown_tomorrow": "mañana",
      "countdown_days": "en {{n}} días",
      "events_done_tooltip": "Eventos confirmados cuya fecha ya pasó. Los presupuestos no aceptados no se cuentan."
    }
  },
  "navbar": {
    "home": "Inicio",
    "wedding": "Eventos",
    "contracts": "Contratos",
    "profile": "Perfil",
    "settings": "Ajustes",
    "calendar": "Calendario",
    "feedback": "Feedback",
    "notifications": "Notificaciones",
    "mark_all_read": "Marcar todas como leídas",
    "no_notifications": "Sin notificaciones",
    "logout": "Salir",
    "collaborations": "Agenda",
    "pricelist": "Tarifas",
    "hello": "Hola",
    "more": "Más",
    "statistics": "Estadísticas"
  },
  "login": {
    "title": "Accede a tu cuenta",
    "username": "Usuario",
    "password": "Contraseña",
    "submit": "Acceder",
    "remember": "Recordarme",
    "noAccount": "¿No tienes una cuenta?",
    "register": "Regístrate",
    "error": "Credenciales incorrectas",
    "username_or_email": "Email o nombre de usuario",
    "resend_confirmation_link": "Reenviar email de confirmación",
    "tagline": "Menos papeleo, más tiempo para tu oficio: Nyzed lo tiene todo bajo control, desde el primer contrato hasta el último retoque.",
    "feature1_label": "Orga-nized",
    "feature1": "contratos en un clic",
    "feature2_label": "Synchro-nized",
    "feature2": "calendario siempre actualizado",
    "feature3_label": "Recog-nized",
    "feature3": "fichas de cliente completas",
    "or_divider": "o",
    "forgot_password": "¿Olvidaste tu contraseña?"
  },
  "register": {
    "title": "Crea tu cuenta",
    "name": "Nombre",
    "lastname": "Apellido",
    "username": "Usuario",
    "email": "Email",
    "password": "Contraseña",
    "submit": "Registrarse",
    "hasAccount": "¿Ya tienes una cuenta?",
    "login": "Acceder",
    "pending": "¡Registro completado! Tu cuenta está pendiente de aprobación.",
    "tagline": "Tu próxima boda empieza aquí. Crea tu cuenta gratuita y deja que Nyzed se encargue de la organización.",
    "feature1_label": "Orga-nized",
    "feature1": "contratos en un clic",
    "feature2_label": "Synchro-nized",
    "feature2": "calendario siempre actualizado",
    "feature3_label": "Recog-nized",
    "feature3": "fichas de cliente completas",
    "activity_label": "¿A qué te dedicas?",
    "trucco": "Maquillaje",
    "capelli": "Peluquería",
    "fotografia": "Fotografía",
    "data_label": "Tus datos",
    "confirm_password": "Confirmar contraseña",
    "email_invalid": "Introduce un email válido",
    "check_email_title": "Revisa tu email",
    "check_email_text": "Te hemos enviado un enlace para confirmar tu cuenta. Ábrelo para poder iniciar sesión.",
    "check_email_hint": "Revisa también la carpeta de spam.",
    "or_divider": "o"
  },
  "confirm_email": {
    "tagline": "Un último paso antes de empezar a usar Nyzed.",
    "confirming_title": "Confirmando",
    "confirming_text": "Estamos confirmando tu email, un momento...",
    "success_title": "Email confirmado",
    "success_text": "Tu cuenta está activa. Serás redirigido al login en unos segundos.",
    "invalid_title": "Enlace no válido",
    "resend_intro": "El enlace no es válido o ha caducado. Introduce tu email para recibir uno nuevo.",
    "resend_placeholder": "Tu email",
    "resend_btn": "Enviar nuevo enlace",
    "resend_loading": "Enviando...",
    "resend_sent": "Si la dirección está registrada y aún no confirmada, recibirás un nuevo enlace en breve.",
    "back_to_login": "← Volver al login"
  },
  "weddings": {
    "title": "Eventos",
    "add": "Nuevo evento",
    "filters": {
      "all": "Todas",
      "upcoming": "Próximas",
      "past": "Pasadas",
      "from": "Desde",
      "to": "Hasta"
    },
    "search": "Buscar por nombre o ubicación...",
    "card": {
      "date": "Fecha",
      "location": "Ubicación",
      "view": "Ver resumen"
    },
    "empty": "No se encontraron eventos.",
    "title_sub": "en agenda",
    "next": "Próximo evento",
    "open_card": "Abrir ficha →",
    "view_list": "Lista",
    "view_map": "Mapa",
    "map_empty": "Ningún evento con dirección para mostrar en el mapa",
    "countdown": "días para el evento",
    "search_bride": "Buscar cliente...",
    "collaborations": "Colaboraciones",
    "collaboration": "Colaboración",
    "open": "Abrir →",
    "filters_toggle": "Filtros",
    "sort": {
      "label": "Ordenar",
      "date": "Por fecha",
      "created": "Últimos añadidos"
    }
  },
  "contracts": {
    "title": "Contratos",
    "empty": "No se encontraron contratos.",
    "generate": "Generar contrato",
    "download": "Descargar",
    "view": "Ver",
    "regenerate": "Regenerar",
    "generated": "Contrato generado",
    "not_generated": "No generado",
    "title_sub": "generados",
    "count": "contratos",
    "total": "Total",
    "this_year": "Este año",
    "this_month": "Este mes",
    "search": "Buscar por nombre...",
    "all_years": "Todos",
    "card_link": "Ficha",
    "tab_generated": "Contratos generados",
    "tab_settings": "Ajustes del contrato",
    "status": {
      "signed": "Firmado",
      "waiting": "Esperando firma",
      "todo": "Por enviar a firmar"
    },
    "regenerate_title": "Regenerar contrato",
    "regenerate_text": "¿Regenerar el contrato de {{name}}? La versión actual se guardará en el historial.",
    "load_error": "No se han podido cargar los datos",
    "empty_cta": "Ir a los eventos"
  },
  "calendar": {
    "title": "Calendario",
    "title_full": "Calendario de Eventos",
    "legend": {
      "wedding": "Boda",
      "test": "Prueba",
      "hint": "Toca para mostrar/ocultar",
      "sopralluogo": "Visita al lugar"
    },
    "kpi": {
      "month_count": "{{count}} eventos este mes",
      "next_today": "Próximo evento: hoy",
      "next_tomorrow": "Próximo evento: mañana",
      "next_in_days": "Próximo evento en {{count}} días",
      "next_none": "Ningún evento programado"
    },
    "quick_create": {
      "placeholder": "Nombre del cliente",
      "cancel": "Cancelar",
      "create": "Crear evento"
    },
    "reminders": {
      "title": "Recordatorios",
      "empty": "Sin recordatorios",
      "placeholder": "Añadir un recordatorio...",
      "remove": "Eliminar",
      "add": "Añadir recordatorio"
    },
    "months": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    "days": [
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb",
      "Dom"
    ],
    "no_events": "Sin eventos",
    "weather": {
      "clear": "¡Sol de sobra! Lleva gafas de sol y protector solar",
      "cloudy": "Algo de nubes, pero nada de qué preocuparse",
      "fog": "Niebla a la vista... sal con unos minutos de margen, ¡por si acaso!",
      "drizzle": "Caerán algunas gotas: un paraguas elegante es la jugada perfecta",
      "rain": "Se espera lluvia de verdad: paraguas grande y plan B listo",
      "snow": "Nieve en camino, mejor organizar los desplazamientos con calma",
      "storm": "Tormenta a la vista: ten listo un plan B bajo techo, ¡mejor prevenir!"
    },
    "modal": {
      "date": "Fecha",
      "contract_signed": "Contrato firmado",
      "contract_pending": "Contrato pendiente",
      "deposit_paid": "Depósito pagado",
      "deposit_pending": "Depósito pendiente",
      "open_event": "Abrir evento",
      "close": "Cerrar"
    },
    "m": {
      "today": "Hoy",
      "tomorrow": "Mañana",
      "prev": "Mes anterior",
      "next": "Mes siguiente",
      "month": "Mes",
      "upcoming": "Próximos",
      "new": "Nuevo",
      "no_events_day": "No hay eventos este día",
      "no_upcoming": "No hay eventos en los próximos 90 días"
    }
  },
  "profile": {
    "title": "Perfil",
    "tabs": {
      "profile": "Perfil",
      "contract": "Datos del Contrato",
      "packages": "Paquetes",
      "services": "Tarifas",
      "team": "Accesos del equipo",
      "visibility": "Visibilidad",
      "appearance": "Apariencia"
    },
    "theme": {
      "title": "Apariencia",
      "subtitle": "Elige la paleta de colores de la app. Las paletas distintas de la predeterminada requieren el plan Pro o Agency.",
      "default_name": "Nyzed",
      "default_desc": "Identidad de marca: naranja y lavanda sobre azul noche",
      "floreale_name": "Romántico Floral",
      "floreale_desc": "Paleta cálida y delicada",
      "caldo_name": "Cálido Original",
      "caldo_desc": "Tonos cálidos y envolventes",
      "lusso_name": "Lujo Moderno",
      "lusso_desc": "Elegante, minimalista, naranja quemado y violeta profundo",
      "botanico_name": "Aurora",
      "botanico_desc": "Naranja vivo y lavanda suave, luminoso y ligero",
      "scura_name": "Elegancia Oscura",
      "scura_desc": "Gris azulado con naranja y violeta, ambiente sofisticado",
      "mediterraneo_name": "Mediterráneo",
      "mediterraneo_desc": "Terracota y lavanda, calidez mediterránea",
      "notte_name": "Noche",
      "notte_desc": "Modo oscuro real, descansa la vista",
      "alto_contrasto_name": "Alto Contraste",
      "alto_contrasto_desc": "Máxima legibilidad, pensado para la accesibilidad: gratis"
    },
    "fields": {
      "name": "Nombre",
      "lastname": "Apellido",
      "username": "Usuario",
      "email": "Email",
      "organization": "Estudio / Nombre comercial",
      "activity": "Actividad",
      "hair": "Peluquera",
      "makeup": "Maquilladora",
      "photo": "Fotógrafa"
    },
    "password": {
      "current": "Contraseña actual",
      "new": "Nueva contraseña",
      "confirm": "Confirmar contraseña"
    },
    "contract": {
      "title": "Encabezado del contrato",
      "address": "Dirección",
      "telephone": "Teléfono",
      "email": "Email del contrato",
      "piva": "NIF/CIF",
      "template": "Plantilla PDF",
      "signature": "Firma digital",
      "clear": "Borrar",
      "save_signature": "Guardar firma",
      "location_requirements": "Requisitos de ubicación (EN)",
      "location_requirements_ita": "Requisitos de ubicación (IT)",
      "payment_terms": "Términos de pago (EN)",
      "payment_terms_ita": "Términos de pago (IT)",
      "cancelation_terms": "Términos de cancelación (EN)",
      "cancelation_terms_ita": "Términos de cancelación (IT)"
    },
    "stats": {
      "weddings": "Total eventos",
      "contracts": "Contratos generados"
    },
    "edit": "Editar perfil",
    "save": "Guardar",
    "cancel": "Cancelar",
    "logout": "Cerrar sesión",
    "change_avatar": "Cambiar",
    "weddings_count": "Eventos",
    "contracts_count": "Contratos",
    "default_services": "Servicios predeterminados",
    "edit_profile_btn": "Editar Perfil",
    "edit_profile_desc": "Tus datos personales y profesionales: se usan en toda la app, desde el panel principal hasta el contrato.",
    "logout_btn": "Cerrar sesión",
    "professional_category_label": "Categoría profesional",
    "operating_area_label": "Zona de trabajo",
    "operating_area_placeholder": "Ej. Toscana, Florencia, Umbría",
    "operating_area_hint": "Las zonas donde trabajas, separadas por comas",
    "category_placeholder": "Selecciona categoría",
    "category_other": "Otro",
    "activity_type": "Tipo de actividad",
    "trucco": "Maquillaje",
    "capelli": "Peluquería",
    "foto": "Foto",
    "service_hint": "Separados por punto y coma ( ; )",
    "change_password_label": "Cambiar Contraseña",
    "new_password_label": "Nueva Contraseña",
    "confirm_password_label": "Confirmar Contraseña",
    "leave_empty": "Dejar en blanco para no cambiar",
    "contract_empty_msg": "Aún no has configurado el contrato",
    "default_contract_title": "Tu contrato de default",
    "default_contract_desc": "Es el punto de partida para cada nuevo evento. Puedes modificarlo cuando quieras, y para un evento concreto puedes personalizarlo igualmente sin tocar esta plantilla.",
    "configure_wizard_btn": "✦ Configurar con asistente",
    "guided_wizard_btn": "✦ Asistente guiado",
    "free_edit_btn": "Edición libre",
    "configure_title": "Configura tu contrato",
    "configure_desc": "Introduce tus datos y cláusulas para poder generar contratos para tus novias.",
    "start_config_btn": "Iniciar configuración",
    "studio_data": "Datos del Estudio",
    "edit_btn": "Editar",
    "studio_name_label": "Nombre del estudio / actividad",
    "full_name_label": "Nombre completo",
    "address_label": "Dirección",
    "phone_label": "Teléfono",
    "piva_label": "NIF/CIF",
    "travel_rate_label": "Tarifa de desplazamiento (€/km)",
    "travel_rate_hint": "Coste por kilómetro para llegar a la ubicación. Se multiplica por los kilómetros de ida y vuelta para proponer el coste de desplazamiento de cada evento (luego editable). A título orientativo: 0,20–0,50 €/km.",
    "payment_section": "Pago",
    "deposit_amount_label": "Importe de la señal (€)",
    "deposit_method_q": "¿Cómo se paga la señal?",
    "deposit_method_label": "Método de pago de la señal",
    "cash": "Efectivo",
    "transfer": "Transferencia",
    "both": "Ambos",
    "final_when_q": "¿Cuándo se paga el saldo?",
    "wedding_day_opt": "El día del evento",
    "wedding_day_short": "Día evento",
    "days_before_opt": "Días antes",
    "how_many_days_label": "¿Cuántos días antes?",
    "preview_clause": "Vista previa de la cláusula",
    "preview_payment": "✦ Vista previa del pago",
    "preview_location": "✦ Vista previa de la ubicación",
    "preview_cancellation": "✦ Vista previa de la cancelación",
    "preview_generated": "✦ Vista previa de la cláusula generada",
    "location_reqs": "Requisitos de Ubicación",
    "work_table": "Mesa de trabajo",
    "natural_light": "Luz natural",
    "power_outlet": "Enchufe eléctrico",
    "additional_notes_label": "Texto libre",
    "other_needs": "¿Otras necesidades?",
    "work_table_full": "Una mesa de trabajo",
    "natural_light_full": "Luz natural adecuada",
    "power_outlet_full": "Un enchufe eléctrico",
    "cancellation_section": "Cancelación",
    "deposit_refundable_q": "¿Es reembolsable la señal en caso de cancelación?",
    "deposit_refundable_tooltip": "Si eliges \"No reembolsable\", la señal queda para ti aunque el cliente cancele el evento: es la garantía que cubre el tiempo que le reservaste.",
    "deposit_refundable_short": "¿Es reembolsable la señal?",
    "deposit_refundable_short2": "¿Señal reembolsable?",
    "yes_refundable": "Sí, reembolsable",
    "yes_short": "Sí",
    "no_refundable": "No, no reembolsable",
    "no_short": "No",
    "postponement_q": "¿En caso de aplazamiento de la fecha?",
    "postponement_tooltip": "Decide qué ocurre con el depósito ya pagado si se cambia la fecha del evento: sigue siendo válido para la nueva fecha o se reembolsa al cliente.",
    "postponement_policy_label": "Política de aplazamiento",
    "transfer_date_opt": "Señal transferida a la nueva fecha",
    "transfer_short": "Transferida",
    "keep_deposit_opt": "Señal retenida",
    "keep_deposit_short": "Retenida",
    "cancellation_notes_label": "Notas de cancelación",
    "template_firma": "Plantilla y Firma",
    "template_pdf_label": "Plantilla PDF",
    "preview_template": "Vista previa",
    "preview_template_title": "Vista previa del contrato",
    "close": "Cerrar",
    "no_signature": "Sin firma cargada",
    "draw_signature": "Dibuja tu firma aquí",
    "redraw_signature": "Vuelve a dibujar para actualizar",
    "clear_signature": "Borrar",
    "save_signature_btn": "Guardar Firma",
    "free_contract_text": "Texto libre del contrato",
    "free_contract_hint": "Escribe el texto de cada sección. Usa variables para insertar datos reales al generar.",
    "save_contract_text_btn": "Guardar texto del contrato",
    "packages_services": "Paquetes y Servicios",
    "packages_desc": "Define tus paquetes estándar: se precargarán en cada nueva boda",
    "no_packages": "Aún no hay paquetes. ¡Añade uno!",
    "add_package": "+ Añadir paquete",
    "show_total_contract": "Mostrar total en el contrato",
    "total_shown": "El total de los servicios se mostrará en el contrato",
    "total_hidden": "El total no se mostrará en el contrato",
    "services_list_title": "Tarifas de Servicios",
    "services_list_desc": "Define tus servicios individuales: podrás seleccionarlos para cada boda",
    "add_service": "+ Añadir",
    "no_services": "Aún no hay servicios",
    "no_services_desc": "Añade tus servicios a las tarifas.",
    "add_service_btn": "+ Añadir servicio",
    "service_discount_name": "Nombre del descuento",
    "service_discount_name_placeholder": "Ej. Oferta de la feria",
    "service_discount_toggle": "Descuento activo",
    "service_discount_price": "Precio con descuento",
    "service_discount_until": "Válido hasta",
    "service_discount_badge": "Descuento hasta",
    "service_desc_label": "Descripción",
    "team_title": "Agenda de colaboradores",
    "team_desc": "Los colaboradores habituales que asignas a los eventos. Quien necesite su propio acceso se invita desde Perfil → Accesos del equipo.",
    "team_add": "+ Añadir",
    "team_empty": "Aún no hay colaboradores",
    "team_empty_desc": "Añade a las personas con las que trabajas para asignarlas a los eventos.",
    "team_add_btn": "+ Añadir colaborador",
    "team_role_label": "Rol",
    "team_notes_label": "Notas",
    "available": "Disponible",
    "not_available": "No disponible",
    "wizard_intro_title": "Configuremos tu contrato",
    "wizard_intro_p1": "Estos son los datos por defecto de tu contrato, guardados en tu perfil.",
    "wizard_intro_p2": "Podrás modificarlos para cada evento desde la ficha del evento.",
    "wizard_intro_start": "Empecemos",
    "chain_step": "Paso {{n}} de 5",
    "listino_chain_title": "Paso 5 de 5: tu lista de precios",
    "listino_chain_text": "Revisa o añade tus servicios, luego continúa a la home.",
    "listino_chain_home_btn": "Ir a la Home →",
    "wizard_step0_title": "¿Quién eres?",
    "wizard_step0_subtitle": "Los datos de tu estudio aparecerán en el encabezado del contrato",
    "wizard_step1_title": "¿Cómo gestionas los pagos?",
    "wizard_step1_subtitle": "Define señal y saldo: el texto de la cláusula se generará automáticamente",
    "wizard_step2_title": "¿Qué necesitas in situ?",
    "wizard_step2_subtitle": "Selecciona los requisitos mínimos para trabajar",
    "wizard_step3_title": "¿Qué pasa si se cancela?",
    "wizard_step3_subtitle": "Define tu política de cancelación",
    "wizard_step4_title": "Elige el aspecto del contrato",
    "wizard_step4_subtitle": "Plantilla y firma digital",
    "wizard_prev": "← Atrás",
    "wizard_next": "Siguiente →",
    "wizard_save": "✦ Guardar contrato",
    "wizard_cancel": "Cancelar",
    "free_edit_title": "Editar Contrato",
    "studio_name_short": "Nombre del estudio",
    "location_notes_label": "Notas de ubicación",
    "save_all": "Guardar todo",
    "Template": "Plantilla",
    "final_method_q": "¿Cómo se paga el saldo?",
    "package_name_placeholder": "Nombre del paquete",
    "service_name_placeholder": "Nombre del servicio",
    "price_placeholder": "Precio €",
    "service_desc_placeholder": "Ej. incluye prueba de maquillaje",
    "team_name_placeholder": "Nombre",
    "team_lastname_placeholder": "Apellido",
    "team_email_placeholder": "email@ejemplo.com",
    "team_notes_placeholder": "Notas libres...",
    "location_access_placeholder": "Ej. acceso anticipado 30 minutos antes...",
    "visibility": {
      "title": "Visibilidad de secciones",
      "subtitle": "Elige qué secciones de los eventos pueden ver tus colaboradores y tu equipo. Estos son los valores predeterminados, ajustables por evento.",
      "collaborators": "Colaboradores",
      "team": "Equipo",
      "save": "Guardar visibilidad",
      "sections": {
        "event_data": "Datos del evento",
        "trial": "Prueba / Inspección",
        "photos": "Fotos",
        "client": "Cliente",
        "services": "Servicios y costes",
        "participants": "Clientes",
        "contract": "Contrato",
        "documents": "Documentos"
      }
    },
    "iban_label": "IBAN",
    "iban_placeholder": "IT00 A000 0000 0000 0000 0000 000",
    "other_section": "Otro",
    "other_section_tooltip": "Añade una cláusula personalizada: el título y el texto se imprimirán tal cual los escribes en el PDF del contrato.",
    "other_title_label": "Título",
    "other_title_placeholder": "Ej. Cláusula adicional",
    "other_text_label": "Texto libre",
    "listino": {
      "load_error": "Error al cargar la lista de precios",
      "remove_title": "Eliminar servicio",
      "remove_text": "¿Seguro que quieres eliminar este servicio?",
      "discount_invalid": "Un descuento activo necesita un precio inferior al precio completo y una fecha de fin",
      "name_required": "El nombre es obligatorio",
      "saved": "Lista de precios guardada",
      "save_error": "No se pudo guardar la lista de precios"
    },
    "access": {
      "title": "Accesos del equipo",
      "desc": "Las personas de tu equipo que entran en la app con su propia cuenta: reciben un email para crear la contraseña y ven los eventos que les asignas. Los colaboradores sin acceso se gestionan en la Agenda.",
      "email_placeholder": "email@ejemplo.com",
      "invite": "Invitar",
      "empty": "Aún no hay accesos",
      "empty_desc": "Invita a la primera persona escribiendo su email arriba.",
      "active": "Activo",
      "pending": "Pendiente",
      "resend": "Reenviar",
      "remove": "Quitar acceso"
    },
    "rubrica": {
      "pro_lock": "Añade colaboradores con el plan Pro.",
      "on_app": "En Nyzed",
      "invite_app": "Invitar a Nyzed",
      "app_user": "Usuario de Nyzed",
      "desc_short": "Las personas con las que trabajas, para asignarlas a los eventos. Quien necesite su propio acceso va en Accesos del equipo.",
      "add": "Añadir colaborador",
      "name": "Nombre",
      "lastname": "Apellido",
      "available_label": "Disponible para nuevos eventos",
      "load_error": "Error al cargar",
      "invite_sent": "Invitación enviada",
      "invite_error": "No se pudo enviar la invitación",
      "remove_title": "Eliminar colaborador",
      "remove_text": "¿Quieres eliminar a esta persona de la agenda?",
      "saved": "Guardado",
      "save_error": "No se pudo guardar",
      "name_required": "El nombre es obligatorio"
    },
    "logo": {
      "label": "Logotipo",
      "empty": "Ningún logotipo cargado",
      "upload": "Cargar logotipo",
      "change": "Cambiar logotipo",
      "remove": "Quitar",
      "hint": "Aparece en el contrato PDF, el presupuesto, la página de firma y el correo del presupuesto.",
      "invalid": "Elige un archivo de imagen",
      "saved": "Logotipo guardado",
      "removed": "Logotipo eliminado",
      "upload_error": "Error al cargar el logotipo",
      "remove_error": "Error al quitar el logotipo"
    }
  },
  "riepilogo": {
    "tabs": {
      "wedding": "Evento",
      "test": "Ensayo",
      "sopralluogo": "Visita previa",
      "client": "Ficha Cliente",
      "costs": "Costes",
      "logistics": "Servicios",
      "contract": "Contrato",
      "collaborators": "Colaboradores",
      "documents": "Documentos",
      "payments": "Pagos"
    },
    "wedding_tab_desc": "Fecha, hora y ubicación del evento: son los datos que también aparecen en el encabezado del contrato.",
    "test_tab_desc": "Programa la prueba de maquillaje y peluquería antes del gran día.",
    "sopralluogo_tab_desc": "Programa la visita previa a la ubicación antes del evento.",
    "client_tab_desc": "Datos completos de la novia: se usan para generar el contrato y mantener el contacto.",
    "documents_tab_desc": "Sube y organiza documentos útiles para este evento (presupuestos, recibos, moodboards...).",
    "payments": {
      "title": "Pagos",
      "title_desc": "Registra la señal y el saldo, y controla cuánto queda por cobrar.",
      "services": "Servicios",
      "total": "Total",
      "deposit": "Anticipo",
      "balance": "Saldo",
      "paid": "Pagado",
      "collected": "Cobrado",
      "to_collect": "Por cobrar",
      "note_placeholder": "Nota (ej. fecha, método)",
      "save": "Guardar pagos",
      "saving": "Guardando…",
      "saved": "Pagos guardados",
      "received": "Cobrado",
      "received_on": "Cobrado el",
      "paid_at": "Fecha de cobro",
      "method": "Método",
      "due_date": "Vencimiento",
      "due_on": "Vence",
      "overdue": "Saldo vencido el {{date}}",
      "share_summary": "Enviar resumen a la clienta",
      "state_received": "recibido",
      "state_pending": "pendiente",
      "save_error": "No se pudo guardar el pago",
      "methods": {
        "cash": "Efectivo",
        "transfer": "Transferencia",
        "card": "Tarjeta",
        "other": "Otro"
      }
    },
    "wedding": {
      "date": "Fecha del evento",
      "time": "Hora",
      "location": "Ubicación",
      "contract_date": "Fecha del contrato",
      "notes": "Notas"
    },
    "test": {
      "date": "Fecha del ensayo",
      "time": "Hora",
      "location": "Ubicación",
      "notes": "Notas",
      "photos": "Fotos del ensayo"
    },
    "client": {
      "name": "Nombre",
      "lastname": "Apellido",
      "address": "Dirección",
      "dob": "Fecha de nacimiento",
      "pob": "Lugar de nacimiento",
      "services": "Servicios"
    },
    "costs": {
      "total": "Total",
      "deposit": "Señal",
      "balance": "Saldo",
      "travel": "Desplazamiento",
      "paid": "Pagado",
      "not_paid": "No pagado"
    },
    "collab_banner": "Estás viendo esta boda como colaborador",
    "organized_by": "organizada por",
    "wedding_card": "Ficha evento",
    "contract_section": "Contrato",
    "no_contract": "Sin contrato generado",
    "generate_contract": "Generar Contrato",
    "view": "Ver",
    "download": "Descargar",
    "regenerate": "Regenerar",
    "preview_title": "Vista previa del contrato",
    "finalize": "Finalizar y generar",
    "cancel_preview": "Cancelar",
    "generate_signature": "Generar enlace de firma del cliente",
    "link_valid": "Enlace de firma (válido 7 días)",
    "copy": "Copiar",
    "share_hint": "Compartir por WhatsApp o email",
    "signed_at_prefix": "Firmado el",
    "generate_signed_pdf": "Generar PDF firmado",
    "signed_pdf_done": "PDF firmado generado",
    "hide_history": "▲ Ocultar historial",
    "show_history": "▼ Historial de versiones",
    "no_history": "Sin versiones anteriores",
    "signed_badge": "✓ Firmado",
    "contract_name_label": "Nombre del Contrato",
    "contract_date_label": "Fecha del Contrato",
    "notes_section": "Notas",
    "trial_date": "Fecha del Ensayo",
    "trial_time": "Hora del Ensayo",
    "trial_cost": "Coste del ensayo",
    "travel": {
      "label": "Desplazamiento",
      "manual_title": "Importe manual",
      "auto_title": "Cálculo automático",
      "auto_hint": "Introduce el coste por km y pulsa Calcular: sobrescribe el importe manual con distancia ida y vuelta × €/km. Precargado con tu tarifa por defecto.",
      "total": "total",
      "per_km": "/km",
      "calculate": "Calcular",
      "calculating": "Calculando…",
      "breakdown": "≈ {{km}} km ida y vuelta × {{rate}} €/km",
      "no_rate": "Distancia {{km}} km ida y vuelta. Introduce un coste por km mayor que 0 para calcular el importe.",
      "no_base": "Configura primero la dirección base en los ajustes del contrato",
      "no_location": "Introduce primero la ubicación del evento",
      "error": "No se ha podido calcular la distancia para esta dirección"
    },
    "open_maps": "Abrir en mapas",
    "trial_location": "Ubicación del Ensayo",
    "sopralluogo_date": "Fecha Visita previa",
    "sopralluogo_time": "Hora Visita previa",
    "sopralluogo_location": "Ubicación Visita previa",
    "photos_section": "Fotos",
    "no_photos": "Sin fotos cargadas",
    "drop_photos": "Arrastra las fotos aquí o haz clic para seleccionar",
    "documents_section": "Documentos",
    "no_documents": "Sin documentos cargados",
    "drop_documents": "Arrastra los documentos aquí o haz clic para seleccionar",
    "documents_unit": "documentos",
    "document_name_placeholder": "Nombre del documento",
    "document_note_placeholder": "Añade una nota...",
    "uploading": "Cargando...",
    "logistics_title": "Servicios",
    "logistics_tab_desc": "Servicios elegidos, precios, desplazamiento y descuento de este evento.",
    "services_section": "Servicios",
    "custom_service": {
      "add": "Añadir concepto fuera de tarifas",
      "name": "Nombre del concepto",
      "description": "Descripción (opcional)",
      "remove": "Quitar concepto",
      "badge": "Fuera de tarifas"
    },
    "no_services_profile": "Sin servicios en las tarifas",
    "add_from_profile": "añádelos desde el perfil",
    "no_services_selected": "Sin servicio seleccionado",
    "packages_section": "Paquetes",
    "no_packages_selected": "Sin paquete seleccionado",
    "add_custom_package": "+ Añadir paquete personalizado",
    "summary_section": "Resumen",
    "no_services_packages": "Sin servicio o paquete seleccionado",
    "show_prices": "Mostrar precios individuales en el contrato",
    "show_total": "Mostrar total en el contrato",
    "participants_section": "Clientes",
    "no_participants": "Sin clientes añadidos",
    "name_optional": "Nombre (opcional)",
    "notes_placeholder": "Notas...",
    "add_participant": "+ Añadir",
    "team_tab": "Equipo y Colaboradores",
    "team_tab_desc": "Asigna tu equipo fijo o invita a colegas a ver y gestionar este evento contigo.",
    "team_status_assigned": "Asignado",
    "team_status_pending": "Pendiente",
    "team_status_accepted": "✓ Confirmado",
    "team_status_rejected": "✗ Rechazado",
    "team_resend": "↺ Reenviar",
    "team_empty": "Sin miembros asignados",
    "team_add_from": "Añadir del equipo",
    "contract_tab": "Contrato",
    "contract_tab_desc": "Genera el PDF, gestiona la firma digital y consulta el historial de versiones del contrato.",
    "contract_custom": "Cláusulas personalizadas para esta novia",
    "free_text_section": "Texto libre",
    "override_note": "Anulación para esta novia: variables sustituidas al generar el PDF",
    "restore_from_profile": "↺ Restaurar desde perfil",
    "text_from_profile": "Texto cargado desde el perfil",
    "text_from_profile_desc": "Edítalo libremente, se guardará solo para esta novia.",
    "no_text_configured": "Sin texto configurado",
    "save_contract_text": "Guardar texto del contrato",
    "missing": {
      "title": "Para el contrato faltan",
      "add_time": "Añadir hora",
      "add_location": "Añadir lugar",
      "add_phone": "Añadir teléfono",
      "add_email": "Añadir email"
    },
    "edit_btn": "Editar",
    "save_btn": "Guardar",
    "delete_event": "Eliminar evento",
    "upload_action": "Subir",
    "photos_unit": "fotos",
    "it_text_prefix": "Texto IT para",
    "en_text_prefix": "Texto EN para",
    "contract_tab_all_note": "Todos los campos de esta sección aparecen en el contrato",
    "visibility": {
      "title": "Visibilidad de secciones",
      "hint": "Personaliza qué ven colaboradores y equipo SOLO para este evento. Déjalo igual para usar los valores del perfil.",
      "save": "Guardar para este evento",
      "reset": "Restaurar valores del perfil",
      "collaborators_see": "Qué ven los colaboradores",
      "team_see": "Qué ve el equipo"
    },
    "in_contract": "en el contrato",
    "add_photo": "Añadir",
    "delete_photo": "Eliminar foto",
    "edit_document": "Editar documento",
    "delete_document": "Eliminar documento",
    "team_add": "Añadir personas",
    "team_pro_lock": "Añade equipo y colaboradores con el plan Pro.",
    "team_pro_cta": "Pasar a Pro",
    "team_group_team": "Equipo",
    "team_group_collaborators": "Colaboradores",
    "team_picker_empty": "No hay miembros disponibles.",
    "send_for_signature": "Enviar para firmar",
    "share_signature_link": "Compartir el enlace de firma",
    "regenerate_signature_link": "Generar un enlace nuevo",
    "customize_contract": "Personalizar los textos del contrato",
    "signature_link_error": "No se pudo generar el enlace de firma",
    "regenerate_signed_title": "Contrato ya firmado",
    "regenerate_signed_text": "Este contrato ya está firmado. Si lo regeneras, la firma actual dejará de ser válida y la clienta tendrá que firmar de nuevo. La versión firmada queda en el historial. ¿Continuar?",
    "discount": {
      "label": "Descuento",
      "description": "Descripción (opcional)",
      "description_placeholder": "Ej. Reserva anticipada",
      "include_travel": "Aplicar también al desplazamiento"
    },
    "signature_link_expired_title": "Contrato por regenerar",
    "signature_link_expired": "El enlace de firma se ha anulado porque los datos del contrato han cambiado: vuelve a generar el contrato y envíalo de nuevo.",
    "signature_share_title": "Firma del contrato",
    "signature_share_text": "Hola {{name}}, aquí tienes el enlace para leer y firmar el contrato:",
    "hero": {
      "today": "Hoy",
      "tomorrow": "Mañana",
      "in_days": "En {{n}} días",
      "past": "Finalizado",
      "contract_todo": "Contrato pendiente",
      "contract_ready": "Contrato listo",
      "contract_waiting": "Esperando firma",
      "contract_signed": "Contrato firmado",
      "pay_none": "Sin importe",
      "pay_done": "Pagado",
      "pay_todo": "Por cobrar {{amount}}",
      "pay_overdue": "Saldo vencido: {{amount}}",
      "team_none": "Sin colaboradores",
      "team_pending": "{{n}} pendientes",
      "team_ok": "Equipo: {{n}}",
      "directions": "Cómo llegar",
      "call": "Llamar",
      "email": "Email",
      "share": "Compartir",
      "more": "Más",
      "copied": "Copiado al portapapeles"
    },
    "contract_steps": {
      "generate": "Generar",
      "send": "Enviar",
      "sign": "Firma",
      "signed_pdf": "PDF firmado"
    },
    "contract_stage": {
      "draft": "Genera el contrato con los datos de este evento.",
      "ready": "Contrato listo: envíalo a la clienta para la firma online.",
      "sent": "Esperando la firma de la clienta. El enlace es válido hasta el {{expires}}.",
      "signed": "La clienta firmó el {{signed}}: genera el PDF firmado.",
      "done": "Contrato firmado y archivado."
    }
  },
  "feedback": {
    "title": "Ayúdanos a mejorar Nyzed",
    "subtitle": "Eres de las primeras en usar Nyzed. Tu opinión vale muchísimo.",
    "nps": "¿Con qué probabilidad recomendarías Nyzed a una colega?",
    "subscription": "¿Estarías interesada en una suscripción?",
    "yes": "Sí, me interesa",
    "no": "No, no me interesa",
    "price": "¿Cuánto pagarías al mes?",
    "features": "¿Qué funcionalidades usas más?",
    "missing": "¿Qué te gustaría que tuviera Nyzed?",
    "submit": "Enviar feedback",
    "thanks": "¡Muchas gracias!",
    "already": "Ya has enviado tu feedback.",
    "thanks_desc": "Tu feedback nos ayudará a construir la versión definitiva de Nyzed.",
    "beta_discount": "Como beta tester recibirás un descuento permanente en el lanzamiento oficial de la suscripción.",
    "back_home": "Volver al inicio",
    "nps_hint": "1 = para nada, 10 = absolutamente sí",
    "nps_legend_low": "Para nada",
    "nps_legend_high": "Absolutamente sí",
    "subscription_hint": "Nyzed será de pago tras la fase beta",
    "price_label": "¿Cuánto pagarías al mes?",
    "features_hint": "Selecciona todas las que te resulten útiles",
    "missing_hint": "Funcionalidades que faltan, mejoras, ideas libres",
    "missing_placeholder": "Ej. notificaciones por email, app móvil, integración con Google Calendar...",
    "beta_promise_title": "Descuento permanente para beta testers",
    "beta_promise_desc": "Al completar este cuestionario, recibirás un descuento exclusivo y permanente cuando Nyzed lance su suscripción oficial.",
    "update": "Actualizar feedback"
  },
  "firma": {
    "loading": "Cargando...",
    "expired_title": "Enlace caducado",
    "expired_desc": "Este enlace de firma ha caducado. Contacta con tu artista de bodas para recibir uno nuevo.",
    "signed_title": "Contrato firmado",
    "signed_desc": "Ya has firmado este contrato. ¡Gracias!",
    "error_title": "Enlace no válido",
    "eyebrow": "Firmar contrato",
    "confirm_text": "Al firmar este documento confirmas que has leído y aceptado las condiciones del contrato de servicio.",
    "valid_until": "Enlace válido hasta el:",
    "subtotal": "Subtotal",
    "read_contract": "Leer el contrato",
    "services_title": "Servicios incluidos",
    "total": "Total",
    "signature_label": "Tu firma",
    "signature_hint": "Dibuja tu firma aquí con el dedo o el ratón",
    "clear": "↺ Borrar",
    "submit": "Firmar y confirmar",
    "submitting": "Enviando...",
    "legal": "Al firmar digitalmente aceptas las condiciones del contrato. La firma se guardará y se asociará a tu nombre."
  },
  "novita": {
    "eyebrow": "Nyzed",
    "title": "Novedades y Actualizaciones",
    "subtitle": "Todas las novedades, mejoras y correcciones de Nyzed",
    "current_version": "Versión actual"
  },
  "not_found": {
    "title": "¡En construcción!",
    "message": "Esta página aún está en desarrollo. ¡Vuelve pronto para ver las novedades!",
    "back": "Volver al inicio"
  },
  "crea": {
    "eyebrow": "Nuevo",
    "title": "Añadir",
    "title_sub": "evento",
    "services": "Servicios",
    "packages": "Paquetes",
    "total": "Total",
    "show_prices": "Mostrar precios individuales en el contrato",
    "show_total": "Mostrar total en el contrato",
    "contract_section": "Contrato y Notas",
    "generate_contract": "Generar contrato",
    "generate_contract_sub": "El PDF se generará automáticamente al guardar",
    "generate_contract_tooltip": "Si todavía no tienes todos los datos puedes dejarlo desactivado: podrás generar el contrato en cualquier momento desde la ficha del evento.",
    "contract_hint": "Completa todos los datos de la novia, fecha de boda y ubicación para activar",
    "contract_date": "Fecha del contrato",
    "contract_name": "Nombre del contrato",
    "contract_fields_tooltip": "Sirven para identificar el documento: pueden ser distintos de la fecha de la boda (por ejemplo, la fecha en que firmáis el contrato).",
    "contract_name_placeholder": "Ej. Contrato Sofía García",
    "notes": "Notas",
    "notes_placeholder": "Notas libres...",
    "cancel": "Cancelar",
    "submit": "Guardar evento →",
    "required": "Campo obligatorio",
    "bride": {
      "section": "Cliente",
      "name": "Nombre",
      "lastname": "Apellido",
      "email": "Email",
      "address": "Dirección de residencia",
      "dob": "Fecha de nacimiento",
      "pob": "Lugar de nacimiento",
      "name_placeholder": "Ej. Sofía",
      "lastname_placeholder": "Ej. García",
      "email_placeholder": "sofia@email.com",
      "address_placeholder": "Calle Mayor 1, Madrid",
      "pob_placeholder": "Ej. Madrid",
      "phone": "Teléfono",
      "phone_placeholder": "Ej. 612 345 678"
    },
    "wedding": {
      "section": "Evento",
      "date": "Fecha",
      "time": "Hora",
      "location": "Ubicación",
      "test_date": "Fecha del ensayo",
      "test_time": "Hora del ensayo",
      "test_location": "Ubicación del ensayo",
      "location_placeholder": "Ej. Villa Borghese, Roma",
      "test_location_placeholder": "Ej. Estudio, Madrid",
      "test_cost": "Coste del ensayo",
      "test_cost_placeholder": "Ej. 80"
    },
    "new_title": "Nuevo evento",
    "optional_hint": "Basta con el nombre y la fecha. El resto puedes añadirlo ahora o más tarde desde la ficha del evento.",
    "sections": {
      "client": "Datos para el contrato",
      "trial": "Prueba",
      "sopralluogo": "Visita al lugar",
      "services": "Servicios y desplazamiento"
    },
    "summary": {
      "filled": "{{n}}/{{total}} completados"
    },
    "cost": "Coste",
    "qty_less": "Reducir cantidad",
    "qty_more": "Aumentar cantidad",
    "travel_pro": "El cálculo automático del desplazamiento está disponible con el plan Pro o Agency.",
    "listino_panel": {
      "open": "añade una partida",
      "title": "Nueva partida de la lista de precios",
      "desc": "La guardamos en tu lista de precios y la añadimos a este evento. Lo que has escrito en el formulario se mantiene.",
      "save": "Guardar y añadir"
    },
    "missing_title": "Para generar el contrato faltan:",
    "missing": {
      "name": "Nombre de la clienta",
      "date": "Fecha del evento",
      "location": "Lugar",
      "lastname": "Apellido",
      "address": "Dirección",
      "dob": "Fecha de nacimiento",
      "pob": "Lugar de nacimiento",
      "services": "Al menos un servicio"
    },
    "create": "Crear evento",
    "saving": "Guardando…",
    "missing_confirm_title": "Faltan datos para el contrato",
    "missing_confirm_text": "Para generar el contrato se necesita: {{list}}. ¿Quieres completarlos o crear el evento sin contrato?",
    "create_without": "Crear sin contrato",
    "complete_data": "Completar datos",
    "period": {
      "label": "Periodo aproximado",
      "year": "Año",
      "any": "Mes o estación (opcional)",
      "hint": "Sin una fecha exacta el presupuesto queda fuera del calendario. La fecha es necesaria para generar el contrato.",
      "no_date": "Fecha por definir",
      "jan": "Enero",
      "feb": "Febrero",
      "mar": "Marzo",
      "apr": "Abril",
      "may": "Mayo",
      "jun": "Junio",
      "jul": "Julio",
      "aug": "Agosto",
      "sep": "Septiembre",
      "oct": "Octubre",
      "nov": "Noviembre",
      "dec": "Diciembre",
      "spring": "Primavera",
      "summer": "Verano",
      "autumn": "Otoño",
      "winter": "Invierno",
      "date_needed": "Indica la fecha del evento para generar el contrato"
    }
  },
  "changelog_modal": {
    "eyebrow": "Novedades",
    "version": "Versión",
    "view_all": "Ver historial completo",
    "cta": "Genial, continuar →"
  },
  "beta_modal": {
    "title": "Bienvenida a la versión beta de Nyzed",
    "desc": "Estás entre las primeras en usar esta app. Todavía estamos mejorando todo: tu feedback es valioso y nos ayudará a construir la versión definitiva.",
    "gift_title": "Regalo para los beta testers",
    "gift_desc": "Los participantes de la beta recibirán un descuento permanente en la suscripción en el lanzamiento oficial.",
    "feedback_btn": "Deja tu feedback",
    "skip_btn": "Lo haré después"
  },
  "blocks": {
    "section_title_placeholder": "Título de sección",
    "deposit_label": "Depósito (€)",
    "deposit_method_label": "Método de depósito",
    "cash": "Efectivo",
    "transfer": "Transferencia bancaria",
    "both": "Ambos",
    "iban_label": "IBAN",
    "paypal_label": "PayPal (opcional)",
    "final_when_label": "Cuándo pagar el saldo",
    "wedding_day_opt": "Día del evento",
    "days_before_opt": "Días antes",
    "how_many_days": "Cuántos días antes",
    "final_method_label": "Método de saldo",
    "preview_label": "✦ Vista previa",
    "work_table": "Mesa de trabajo",
    "natural_light": "Luz natural",
    "power_outlet": "Toma de corriente",
    "additional_notes": "Notas adicionales",
    "other_needs_placeholder": "Otras necesidades...",
    "cancellation_deposit_label": "Depósito en caso de cancelación",
    "refundable": "Reembolsable",
    "not_refundable": "No reembolsable",
    "postponement_label": "En caso de aplazamiento",
    "transfer_date": "Depósito transferido a la nueva fecha",
    "keep_deposit": "Depósito retenido",
    "cancellation_notes_placeholder": "Condiciones particulares...",
    "custom_text_label": "Texto de la cláusula",
    "custom_text_placeholder": "Escribe aquí el texto de la cláusula...",
    "empty_state": "Sin bloques todavía. Añade uno abajo.",
    "add_block_label": "Añadir bloque",
    "add_payment": "Pago",
    "add_location": "Ubicación",
    "add_cancellation": "Cancelación",
    "add_custom": "Nota libre",
    "remove_title": "Eliminar bloque"
  },
  "common": {
    "load_failed": "No se pudieron cargar los datos. Comprueba la conexión e inténtalo de nuevo.",
    "retry": "Reintentar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Eliminar",
    "confirm": "Confirmar",
    "close": "Cerrar",
    "loading": "Cargando...",
    "error": "Se ha producido un error",
    "success": "Operación completada",
    "caps_lock_on": "Bloq Mayús activado",
    "show_password": "Mostrar contraseña",
    "hide_password": "Ocultar contraseña"
  },
  "signature_pad": {
    "draw_tab": "Dibujar",
    "upload_tab": "Subir PNG",
    "upload_cta": "Elige un archivo PNG",
    "upload_remove": "Eliminar",
    "upload_invalid_type": "Sube un archivo PNG.",
    "upload_too_large": "El archivo es demasiado grande (máx. 5MB)."
  },
  "deposit_toggle": {
    "fixed": "Fijo",
    "percent": "Porcentaje"
  },
  "google_signin": {
    "link_confirm_title": "La cuenta ya existe",
    "link_confirm_text": "Ya existe una cuenta Nyzed con este email. ¿Quieres vincularla a tu cuenta de Google?"
  },
  "swal": {
    "error": "Error",
    "success": "Éxito",
    "ok": "Ok",
    "yes": "Sí",
    "delete": "Eliminar",
    "generate": "Generar",
    "contract_lang_title": "Idioma del contrato",
    "contract_lang_text": "Elige el idioma para generar el PDF",
    "missing_data": "Datos faltantes",
    "complete_contract_fields": "Completa estos campos para generar el contrato:",
    "download_failed": "Descarga fallida",
    "contract_open_failed": "No se puede abrir el contrato",
    "event_created": "¡Evento creado con éxito!",
    "fill_required": "Por favor, completa todos los campos obligatorios.",
    "load_error": "Error durante la carga.",
    "generic_error": "Se ha producido un error.",
    "fill_all_required": "¡Completa todos los campos requeridos!",
    "failed_captcha": "Verificación de captcha fallida",
    "password_mismatch": "¡Las contraseñas no coinciden!",
    "registration_success": "¡Registro completado con éxito!",
    "can_login": "Revisa tu email para confirmar la cuenta, luego podrás iniciar sesión.",
    "oops": "Oops...",
    "registration_error": "Error durante el registro, inténtalo de nuevo.",
    "confirm_enable": "¿Reactivar {{name}}?",
    "confirm_disable": "¿Deshabilitar {{name}}?",
    "user_enabled": "Usuario reactivado",
    "user_disabled": "Usuario deshabilitado",
    "operation_failed": "Operación fallida",
    "confirm_delete_user": "¿Eliminar {{name}}?",
    "delete_user_warning": "También se eliminarán todos sus eventos. Esta acción es irreversible.",
    "user_deleted": "Usuario eliminado",
    "delete_failed": "Eliminación fallida",
    "password_min": "La contraseña debe tener al menos 6 caracteres",
    "password_updated": "Contraseña actualizada",
    "password_reset_failed": "Restablecimiento de contraseña fallido",
    "role_updated": "Rol actualizado",
    "subscription_updated": "Suscripción actualizada",
    "subscription_update_failed": "Actualización fallida",
    "events_load_error": "Se ha producido un error al cargar los eventos.",
    "unauthorized": "Acceso no autorizado",
    "forbidden": "No tienes permisos para esta sección"
  },
  "settings": {
    "tour": {
      "section_title": "Tour y Guía",
      "section_desc": "Vuelve a ver el tour guiado de una sección: te llevamos directamente a la página correspondiente.",
      "review": "Volver a ver",
      "review_all": "Volver a ver todos los tours",
      "labels": {
        "home": "Tour Inicio",
        "events": "Tour Lista de eventos",
        "event": "Tour Ficha de evento",
        "profile": "Tour Perfil"
      },
      "reset_event_msg": "Tour restablecido, abre un evento de la lista para volver a verlo",
      "reset_all_msg": "Todos los tours restablecidos"
    },
    "contract_wizard": {
      "section_title": "Configuración del contrato",
      "section_desc": "Revisa paso a paso los datos por defecto del contrato (estudio, pago, ubicación, cancelación, plantilla).",
      "review": "Configurar datos del contrato"
    },
    "notifications": {
      "banner_title": "Personaliza tus notificaciones",
      "banner_desc": "Elige qué correos recibir. Puedes cambiarlos en cualquier momento.",
      "title": "Notificaciones por email",
      "test": "Enviar email de prueba",
      "test_sent": "¡Email de prueba enviado!",
      "test_error": "No se pudo enviar",
      "items": {
        "contract_signed": {
          "label": "Firma del contrato",
          "desc": "Cuando la clienta firma el contrato digital"
        },
        "quote_accepted": {
          "label": "Presupuesto aceptado",
          "desc": "Cuando la clienta acepta un presupuesto"
        },
        "event_reminder": {
          "label": "Recordatorio de evento",
          "desc": "7 días antes de cada evento programado"
        },
        "collaborator_invite": {
          "label": "Invitación de colaboración",
          "desc": "Cuando recibes una invitación de un colega"
        },
        "collaborator_response": {
          "label": "Respuesta de colaboración",
          "desc": "Cuando un colega acepta o rechaza tu invitación"
        },
        "deposit_reminder": {
          "label": "Recordatorio de señal",
          "desc": "Si la señal aún no se ha recibido"
        },
        "contract_expiry": {
          "label": "Contrato sin firmar",
          "desc": "Si faltan 7 días para el evento y el contrato no está firmado"
        },
        "weekly_recap": {
          "label": "Resumen semanal",
          "desc": "Resumen de los eventos de la semana, cada lunes por la mañana"
        },
        "app_news": {
          "label": "Novedades de la app",
          "desc": "Actualizaciones importantes y nuevas funciones de Nyzed"
        }
      }
    },
    "support": {
      "section_title": "Soporte",
      "section_desc": "¿Tienes un problema o una pregunta? Escríbenos por chat.",
      "chat_label": "Chat de soporte",
      "chat_desc": "Normalmente respondemos en pocas horas laborables.",
      "chat_cta": "Abrir el chat"
    },
    "title": "Ajustes",
    "lang": {
      "title": "Idioma",
      "desc": "Cambia el idioma de la app. Los textos que escribes tú (p. ej. las cláusulas del contrato) se quedan en el idioma en que los escribiste."
    },
    "visibility_saved": "Visibilidad guardada",
    "visibility_error": "No se pudo guardar la visibilidad",
    "account": {
      "title": "Cuenta",
      "desc": "Gestiona el acceso a tu cuenta de Nyzed.",
      "password_label": "Cambiar contraseña",
      "password_desc": "Gestiona la contraseña desde tu perfil.",
      "go_profile": "Ir al perfil →",
      "delete_label": "Eliminar cuenta",
      "delete_desc": "Eliminación definitiva de todos los datos.",
      "wip": "En construcción"
    }
  },
  "stats": {
    "title": "Estadísticas",
    "total_events": "Eventos totales",
    "events_in_year": "Eventos en {{year}}",
    "empty": "Aún no hay eventos: las estadísticas se llenan a medida que trabajas.",
    "empty_cta": "Crea tu primer evento",
    "pro": {
      "title": "Desbloquea las estadísticas completas",
      "text": "Con el plan Pro ves cómo va tu negocio: desplazamientos, ciudades, facturación, cobros, estacionalidad, tasa de firma y el mapa de tus eventos.",
      "cta": "Pasar a Pro"
    },
    "kpi": {
      "avg_value": "Valor medio por evento",
      "revenue": "Facturación estimada",
      "collected": "Cobrado",
      "signed": "Contratos firmados",
      "sign_rate": "{{rate}}% de los eventos",
      "busiest": "Mes con más trabajo"
    },
    "in_year": "en {{year}}",
    "estimate_year": "estimación {{year}}",
    "n_events": "{{n}} eventos",
    "estimate": "estimación",
    "charts": {
      "events": "Eventos por mes",
      "revenue": "Facturación por mes",
      "collected": "Cobrado por mes"
    },
    "collected_no_date": "Otros {{amount}} € figuran como cobrados pero sin fecha (registrados antes de la 3.2.0): no aparecen en el gráfico.",
    "travel": {
      "title": "Desplazamientos",
      "km_year": "km en {{year}}",
      "km_upcoming": "km por recorrer",
      "cost": "coste de desplazamientos"
    },
    "cities": {
      "title": "Ciudades",
      "others": "+{{n}} más",
      "empty": "Ninguna ciudad registrada este año."
    },
    "map_title": "Mapa de eventos {{year}}"
  },
  "subscription": {
    "title": "Suscripción",
    "trial_until": "Prueba gratuita hasta el",
    "renews_on": "Se renueva el",
    "active_until": "Activa hasta el",
    "no_renew": ", después no se renueva",
    "cancel_title": "Cancelar suscripción",
    "cancel_text": "Mantendrás el acceso hasta el final del periodo ya pagado. ¿Confirmas?",
    "cancel_confirm": "Cancelar",
    "cancel_done": "Cancelación programada",
    "cancel_error": "No se pudo cancelar",
    "reactivate": "Reactivar suscripción",
    "reactivate_done": "Suscripción reactivada",
    "reactivate_error": "No se pudo reactivar",
    "beta_banner": "Estamos en beta: los planes los activa nuestro equipo. Elige el que te interese y envía una solicitud, te contactaremos.",
    "change_plan": "Cambiar plan",
    "choose_plan": "Elige tu plan",
    "recommended": "Recomendado",
    "per_month": "/mes",
    "features": {
      "unlimited_events": "Eventos ilimitados",
      "pdf_contracts": "Contratos en PDF",
      "price_list": "Lista de servicios",
      "maps_travel": "Mapas y desplazamientos",
      "stats": "Estadísticas",
      "contract_themes": "Temas del contrato",
      "team": "Gestión del equipo",
      "priority_support": "Soporte prioritario"
    },
    "current_plan": "Plan actual",
    "switch_to": "Pasar a {{plan}}",
    "subscribe": "Suscribirse",
    "request_activation": "Solicitar activación",
    "note_stripe": "Pagos gestionados de forma segura con Stripe. Puedes cancelar cuando quieras.",
    "note_beta": "Sin pagos durante la beta: nuestro equipo revisa las solicitudes.",
    "status": {
      "trial": "En prueba",
      "active": "Activa",
      "inactive": "Suspendida",
      "cancelled": "Cancelada"
    },
    "checkout_success": "¡Suscripción activada! Gracias.",
    "checkout_cancel_title": "Operación cancelada",
    "checkout_cancel_text": "El pago no se ha completado.",
    "checkout_error": "No se pudo iniciar el pago",
    "request_title": "¿Te interesa el plan {{plan}}?",
    "request_text": "Durante la beta los planes los activa nuestro equipo. Deja un mensaje (opcional) y te contactaremos.",
    "request_sent": "¡Solicitud enviada! Nuestro equipo te contactará.",
    "request_error": "No se pudo enviar la solicitud"
  },
  "time_picker": {
    "hour": "Hora",
    "minutes": "Minutos"
  },
  "quote": {
    "badge": "Presupuesto",
    "filter": "Presupuestos",
    "home_todo": "Presupuestos pendientes",
    "create_toggle": "Todavía es un presupuesto",
    "create_toggle_sub": "No cuenta como evento confirmado hasta que la clienta acepte",
    "create_btn": "Crear presupuesto",
    "date_busy": "En esta fecha ya tienes un evento confirmado: {{name}}",
    "banner": {
      "draft": "Presupuesto por enviar a la clienta.",
      "sent": "Presupuesto enviado, válido hasta el {{date}}. Recibirás un aviso cuando la clienta acepte.",
      "expired": "El enlace del presupuesto ha caducado."
    },
    "send": "Enviar presupuesto",
    "share_again": "Compartir de nuevo",
    "resend": "Enviar de nuevo",
    "confirm": "Marcar como confirmado",
    "back_to_quote": "Volver a presupuesto",
    "confirmed_msg": "Evento confirmado",
    "reverted_msg": "Evento devuelto a presupuesto",
    "share_title": "Presupuesto",
    "share_text": "Hola {{name}}, aquí tienes el presupuesto para el {{date}}:",
    "link_error": "No se pudo crear el enlace del presupuesto",
    "status_error": "No se pudo actualizar el estado",
    "confirm_date_needed": "Indica la fecha del evento antes de confirmarlo",
    "date_to_set": "Fecha por fijar",
    "link_expired_title": "Presupuesto por reenviar",
    "link_expired": "El enlace del presupuesto se ha anulado porque los datos han cambiado: envíalo de nuevo.",
    "notes_toggle": "Mostrar las notas a la clienta",
    "notes_toggle_sub": "Aparecen en el presupuesto y en el resumen que le envías",
    "notes_visible": "Visibles para la clienta",
    "disclaimer_toggle": "Aviso sobre cambios de precio",
    "disclaimer_toggle_sub": "Añade al presupuesto la nota de que el precio podrá variar si se modifican o añaden servicios",
    "settings": {
      "title": "Presupuestos",
      "desc": "Cuántos días sigue siendo válido el enlace de un presupuesto después de enviarlo.",
      "days": "días",
      "saved": "Validez actualizada"
    },
    "page": {
      "loading": "Cargando...",
      "eyebrow": "Presupuesto",
      "for": "Para {{name}}",
      "trial": "Prueba",
      "inspection": "Visita previa",
      "travel": "Desplazamiento",
      "subtotal": "Subtotal",
      "discount": "Descuento",
      "total": "Total",
      "deposit": "Anticipo al confirmar",
      "valid_until": "Presupuesto válido hasta el",
      "accept": "Acepto el presupuesto",
      "accepting": "Enviando...",
      "accept_note": "Al aceptar confirmas la fecha y los servicios indicados. {{name}} se pondrá en contacto contigo para los siguientes pasos.",
      "accepted_title": "Presupuesto aceptado",
      "accepted_desc": "¡Gracias! La confirmación se ha enviado.",
      "expired_title": "Presupuesto caducado",
      "expired_desc": "Este presupuesto ya no es válido. Pide un nuevo enlace.",
      "error_title": "Enlace no válido",
      "notes": "Notas",
      "price_disclaimer": "El presupuesto se refiere a los servicios indicados. En caso de cambios o añadidos el precio podrá variar."
    },
    "mail": {
      "open": "Copiar correo",
      "title": "Correo del presupuesto",
      "include_link": "Incluir el enlace para aceptar online",
      "include_link_sub": "Si está desactivado el correo solo contiene la información: la clienta no podrá aceptar online",
      "copy": "Copiar correo",
      "copied": "Correo copiado: pégalo en tu programa de correo",
      "copy_error": "No se pudo copiar",
      "greeting": "Hola {{name}},",
      "intro": "te envío el presupuesto para el {{date}}.",
      "cta": "Aceptar el presupuesto online",
      "closing": "Quedo a tu disposición para cualquier duda. ¡Hasta pronto!",
      "language": "Idioma del correo",
      "validity": "Validez del enlace",
      "validity_days": "Días",
      "validity_until": "Hasta el",
      "validity_hint": "Al cambiarla se crea un nuevo enlace: el anterior deja de funcionar",
      "days_confirm_title": "El enlace ya enviado dejará de funcionar",
      "days_confirm_text": "Al cambiar la validez se crea un nuevo enlace: el que ya enviaste a la clienta dejará de funcionar y tendrás que enviarle el nuevo.",
      "days_confirm": "Crear nuevo enlace"
    },
    "variants": {
      "add_first": "Añadir una propuesta alternativa",
      "add": "Añadir propuesta",
      "default_name": "Propuesta {{n}}",
      "untitled": "Sin nombre",
      "name": "Nombre de la propuesta",
      "note": "Nota para la clienta (opcional)",
      "remove": "Eliminar propuesta",
      "remove_title": "¿Eliminar la propuesta?",
      "remove_text": "\"{{name}}\" y sus precios se quitarán del presupuesto.",
      "hint": "La prueba (ficha Evento) y el anticipo (ficha Pagos) siguen la propuesta seleccionada.",
      "choose": "Elijo esta",
      "choose_title": "Elige una propuesta",
      "chosen_named": "Has elegido \"{{name}}\".",
      "summary": "{{count}} propuestas, {{range}} · editar en Servicios"
    }
  },
  "landing": {
    "nav_cta": "Únete a la lista",
    "hero": {
      "eyebrow": "Muy pronto",
      "title_1": "Nyzed simplifica",
      "title_2": "cada uno de tus eventos.",
      "lead": "Clientes, presupuestos, contratos, calendario y cobros: todo en un solo lugar. El gestor para profesionales de la belleza que trabajan en eventos. Estamos a punto de abrir las puertas."
    },
    "form": {
      "placeholder": "Tu email",
      "submit": "Avísame primero",
      "sending": "Un momento...",
      "profession": "¿A qué te dedicas?",
      "prof_makeup": "Maquillaje",
      "prof_hair": "Peluquería",
      "prof_both": "Ambos",
      "prof_other": "Otro",
      "note": "Un solo correo, cuando abramos. Nada de spam.",
      "error_email": "Revisa la dirección de email.",
      "error_captcha": "Verificación de seguridad en curso, inténtalo en un momento.",
      "error_generic": "Algo no ha funcionado, inténtalo de nuevo en breve."
    },
    "done": {
      "title": "¡Estás en la lista!",
      "text": "Te hemos enviado un correo de confirmación. En cuanto abramos, lo sabrás antes que nadie.",
      "share": "Copia el enlace y cuéntaselo a una colega",
      "copied": "Enlace copiado"
    },
    "ticker": {
      "events": "Eventos",
      "quote": "Presupuestos",
      "contract": "Firma online",
      "calendar": "Calendario",
      "money": "Anticipos y saldos",
      "team": "Equipo",
      "pricelist": "Tarifas",
      "stats": "Estadísticas"
    },
    "features": {
      "kicker": "Qué hay dentro",
      "title": "Todo el evento, un solo lugar",
      "lead": "Todo lo que hoy tienes entre chats, hojas y cuadernos, en un solo lugar.",
      "events_title": "Cada evento en una ficha",
      "events_text": "Clienta, fecha, lugar, servicios, equipo y notas: todo junto, siempre a mano.",
      "quote_title": "Presupuestos con un enlace",
      "quote_text": "Crea el presupuesto desde tus tarifas, envíalo y la clienta lo acepta desde el móvil.",
      "contract_title": "Contratos con firma online",
      "contract_text": "El contrato nace de los datos del evento y se firma a distancia, sin imprimir nada.",
      "calendar_title": "Calendario con el tiempo",
      "calendar_text": "De un vistazo las fechas ocupadas y qué tiempo hará el día del evento.",
      "money_title": "Anticipos y saldos bajo control",
      "money_text": "Sabes siempre lo que has cobrado y lo que falta, evento por evento.",
      "team_title": "Tu equipo, coordinado",
      "team_text": "Asigna a quien colabora contigo en los eventos: cada persona ve solo lo que necesita."
    },
    "peek": {
      "kicker": "Avance",
      "title": "Un vistazo dentro",
      "lead": "Algo te lo enseñamos ahora. El resto lo descubres en el lanzamiento.",
      "veil": "Lo descubres en el lanzamiento",
      "shot_1": "El día del evento",
      "shot_2": "El presupuesto con enlace",
      "shot_3": "El calendario"
    },
    "faq": {
      "kicker": "Preguntas",
      "title": "Antes de que lo preguntes",
      "when_q": "¿Cuándo abre Nyzed?",
      "when_a": "Estamos puliendo los últimos detalles y todavía no tenemos una fecha que anunciar. Quien está en la lista la recibe por correo antes que nadie.",
      "when_a_soon": "Estamos puliendo los últimos detalles y todavía no tenemos una fecha que anunciar. Vuelve pronto: la encontrarás aquí.",
      "who_q": "¿Para quién está pensado?",
      "who_a": "Para profesionales del maquillaje, la peluquería y la belleza que trabajan en eventos de todo tipo, por cuenta propia o con un equipo.",
      "price_q": "¿Cuánto costará?",
      "price_a": "Los planes y precios se anunciarán con el lanzamiento. Apuntarte a la lista es gratis y no te compromete a nada.",
      "price_a_soon": "Los planes y precios se anunciarán con el lanzamiento.",
      "mobile_q": "¿Funciona en el móvil?",
      "mobile_a": "Sí. Nyzed se usa desde el navegador, en móvil, tablet y ordenador, sin instalar nada.",
      "email_q": "¿Qué hacéis con mi email?",
      "email_a": "Solo lo usamos para avisarte de la apertura. Puedes pedirnos que lo borremos cuando quieras escribiendo a {{email}}."
    },
    "final": {
      "title": "El asiento en primera fila es tuyo",
      "text_soon": "Estamos a punto de abrir las puertas. Vuelve pronto.",
      "text": "Deja tu email: te escribimos en cuanto abramos."
    },
    "footer": {
      "privacy": "Privacidad",
      "cookie": "Cookies",
      "contact": "Contacto"
    },
    "mock": {
      "event": "Evento",
      "date": "14 de junio",
      "s1": "Maquillaje",
      "s2": "Peinado",
      "s3": "Prueba de maquillaje y peinado",
      "total": "Total",
      "signed": "Contrato firmado",
      "quote_ok": "Presupuesto aceptado",
      "now": "Ahora",
      "deposit": "Anticipo recibido",
      "day": "El día del evento",
      "t3": "Segundo look",
      "t4": "Retoque final",
      "quote": "Presupuesto",
      "accept": "Aceptar el presupuesto",
      "month": "Junio"
    }
  }
}
